import { createBrowserHistory, History } from 'history'

const history = createBrowserHistory({
  basename: process.env.REACT_APP_BASE_PATH,
}) as History & { pushPreservePath: (path: string) => void }

function qs(queryString: string, parameter: string): string {
  const strToMap: Record<string, string> = queryString
    .slice(1)
    .split('&')
    .reduce((acc, item) => {
      const [name, ...value] = item.split('=')
      return {
        ...acc,
        [name]: value.join('='),
      }
    }, {})
  return strToMap[parameter] === undefined ? '' : strToMap[parameter]
}
history.pushPreservePath = (newPath: string) => {
  window.du_ErrorCausingUrl = window.location.href
  history.push(newPath)
}
export { history, qs }
